const RespondentTypes = [
  { id: "-1", name: "Please select respondent type" },
  { id: "Agent", name: "Agent" },
  { id: "Owner", name: "Owner" },
  { id: "Occupier", name: "Occupier" },
];

export default RespondentTypes;
